/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import {generateUUID, getCookie, getMode, setCookie} from '@dvrd/dvr-controls';
import IDate from '@dvrd/idate';
import './settings';
import {CookieAttributes} from 'js-cookie';
import {polyfill} from 'seamless-scroll-polyfill';

declare global {
    interface Window {
        mode: string;
        settings: Record<string, any>;
        modeSettings: Record<string, any>;
    }
}

export let DEVICE_ID = '';

export const setDeviceId = () => {
    let deviceId = getCookie('bowies-device-id');
    const mode = getMode();
    if (!deviceId) {
        deviceId = generateUUID();
        let options: CookieAttributes = {expires: 365};
        if (mode !== 'dev') {
            options.secure = true;
            options.sameSite = 'strict';
        }
        setCookie('bowies-device-id', deviceId, options);
    }
    DEVICE_ID = deviceId;
};

IDate.setLocale('NL-nl');
polyfill({});
setDeviceId();